// config
import * as http from 'utils/http';
import config from 'config';

const addBid = async ({ addBidDto, auctionId }) => {
  return http.post(`${config.API_URL}fleet/auctions/${auctionId}/bids/`, addBidDto);
};

export default addBid;
